import { type AutomationExecution } from '@repo/utils';

export const getAutomationExecution = `
query AutomationExecutions($automationExecutionId: ID) {
  automationExecutions(
    automationExecutionId: $automationExecutionId
  ) {
    automationExecutions {
      id
      status
      startsAt
      endsAt
      executionNodes {
        id
        executionStatus
        additionalOptions
        automationNode {
          id
          nodeType
          nodeSubType
          executionOrder
          description
          status
          additionalOptions
          sourceEdges {
            id
            targetNodeId
            status
          }
        }
      }
      executionEdges {
        id
        executionStatus
        automationEdge {
          id
        }
      }
    }
  }
}
`;

export interface GetAutomationExecutionResponse {
  automationExecutions: {
    automationExecutions: Omit<AutomationExecution, 'automationId'>[];
  };
}
